export const linkStyleOrange = (theme) => ({
  ...theme.typography.hg18ru(theme),
  textDecoration: 'none',
  paddingBottom: '0.2em',
  color: theme.palette.primary.main,
  borderColor: theme.palette.primary.main,
  borderBottom: '1px solid',
});


export const linkStyleLeftArrow = (theme) => ({
  ...linkStyleOrange(theme),
  '&:before': {
    display: 'inline-block',
    content: '"\u2190"',
    marginRight: '0.5em',
  },
  '&:hover:before': {
    animation: 'bounce-horizontal 1s infinite linear',
  },
});

export const linkStyleRightArrow = (theme) => ({
  ...linkStyleOrange(theme),
  '&:after': {
    display: 'inline-block',
    content: '"\u2192"',
    marginLeft: '0.5em',
  },
  '&:hover:after': {
    animation: 'bounce-horizontal 1s infinite linear',
  },
});

export const standardContainer = (theme) => ({
  maxWidth: theme.layout.containerMaxWidth,
  margin: '0 auto',
});


// WEBPACK FOOTER //
// ./src/styles/mixins.js